var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 24.6 24.6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 10.8v3.1h10.8v10.7h3.1V13.9h10.7v-3.1H13.9V0h-3.1v10.8z"
})));
export default SvgPlus;